<template>
    <button type="submit" id="btn-submit" :disabled=isSubDisabled>{{btnText}}</button>
</template>

<script>
export default {
  props: ['btnText'],
  computed: {
    isSubDisabled () {
      return this.$store.state.isSubmitDisabled;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/SubmitButton.vue